export default __webpack_public_path__ + "static/media/background.23f561c0.webp";